<template>
  <drawer
    :visible="drawerVisible"
    title="添加账号"
    size="70%"
    @closeDrawer="close"
  >
    <div class="container">
      <div class="top">
        <el-form
          label-width="100px"
          :rules="rules"
        >
          <el-form-item label="公众号名称：">
            <!-- 公众号名称 -->
            <el-input v-model.trim="addAccountQuery.name" />

            <!-- 循环密钥这类东西 -->
            <div
              v-for="(item,index) in addAccountQuery.attach"
              :key="index"
              style="margin:20px 0px 0px -100px"
            >
              <el-form-item :label="item.description">
                <el-input v-model.trim="item.text" />
              </el-form-item>
            </div>

            <!-- 功能区 -->
            <div class="column-display">
              <el-button
                icon="el-icon-plus"
                circle
                @click="addTimeInput"
              />
              <span style="padding-left: 20px">间隔时间-状态</span>
              <div class="confirm-btn">
                <span v-if="!isModify">
                  <el-button
                    type="primary"
                    plain
                    @click="add"
                  >添加</el-button>
                </span>
              </div>
            </div>

          </el-form-item>

          <el-form-item :key="columnKey" style="width:100%">
            <div class="status-box" style="width:100%">
              <div
                v-for="(item1, index) in addAccountQuery.time_part"
                :key="index"
                style="display: flex; margin: 10px 0px;border-bottom-style: groove; padding-bottom: 13px;"
              >

                <!-- 时间选择区 -->
                <div class="timeSelectionArea">
                  <div
                    style="display: flex;"
                  >
                    <el-time-select
                      v-model="item1.start_time"
                      style="width:120px; margin-right: 14px;"
                      placeholder="起始时间"
                      :picker-options="{
                        start: '00:00',
                        step: '00:01',
                        end: '23:59'
                      }"
                    />
                    <el-time-select
                      v-model="item1.end_time"
                      style="width:120px; margin-right: 14px;"
                      placeholder="结束时间"
                      :picker-options="{
                        start: '00:00',
                        step: '00:01',
                        end: '23:59',
                        minTime: item1.start_time
                      }"
                    />
                  </div>

                  <!-- 可选的项的东西 -->
                  <div v-if="(Object.keys(accountTableData.returnCaliber || {}).length && xuan.type) || accountTableData.struct && accountTableData.struct.length === 2 && Object.keys(accountTableData.returnCaliber || {}).length" style="margin-top: 14px; margin-right: 15px;" class="myType">
                    <el-form-item :label="accountTableData.struct.length === 2 ? '回传类型' : xuan.type">
                      <el-select v-model="item1.return_caliber" placeholder="请选择">
                        <el-option
                          v-for="item3 in accountTableData.struct.length === 2 ? accountTableData.returnCaliber.ADQ : accountTableData.returnCaliber[getSelectType(xuan.type)]"
                          :key="item3.value"
                          :label="item3.description"
                          :value="item3.value"
                        />
                      </el-select>
                    </el-form-item>
                  </div>
                </div>

                <!-- 主体区 -->
                <div class="aa" style="max-height: 200px;  padding-right: 15px;  overflow-y: auto; overflow-x: clip;margin-right: 15px;">
                  <div v-for="item2, index1 in item1.time_part" :key="index1" style="display: flex; align-items: center;">
                    <template v-if="item1.isOpen || !index1">
                      <input
                        v-model.number="item2.time"
                        class="input-border"
                      ><i style="color: #ccc; font-style: normal; white-space: pre;">&nbsp;/&nbsp;分钟</i>

                      <div
                        v-if="accountTableData.struct"
                        style="padding-left: 20px; display: flex; align-items: center;"
                      >
                        <div
                          style="display: flex; align-items: center;"
                        >
                          <template v-for="(typeItem,index2) in accountTableData ? accountTableData.struct : null">
                            <span
                              :key="typeItem.value"
                              style="display: inline-block; margin-right: 19px;"
                              @click="qiehuan(judgeWhether(index2, typeItem.value), typeItem.value, index, index1)"
                            >
                              <el-radio
                                v-model="item2.status"
                                :label="typeItem.value"
                                :disabled="judgeWhether(index2, typeItem.value)"
                                @change="handleSingleChoice"
                              >{{ typeItem.description }}</el-radio>
                            </span>

                          </template>
                        </div>

                        <!-- 功能控制区 -->
                        <i v-if="!index1" class="el-icon-circle-plus" style="cursor: pointer; font-size: 18px;" @click="addTimePart(index)" />
                        <i v-else class="el-icon-remove" style="cursor: pointer; font-size: 18px;" @click="deleteTimeItem(index, index1)" />
                        <el-button v-if="!index1" class="row-display" size="small" type="text" @click="item1.isOpen = !item1.isOpen">{{ item1.isOpen ? '收起' : '展开' }}</el-button>
                        <el-button
                          v-if="index !== 0 && index1 === 0"
                          class="row-display"
                          type="text"
                          size="small"
                          @click="deleteTimeInput(index)"
                        >删除一组</el-button>
                      </div>
                    </template>

                  </div>
                </div>

              </div>
            </div>
          </el-form-item>

        </el-form>
      </div>

      <div class="bottom" style="margin-bottom: 0px">
        <div style="">
          <el-input v-model="drawerAccountListQuery.wechat_name" placeholder="微信名称" style="width: 150px; margin-right: 10px;" />
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button type="primary" @click="reset">重置</el-button>
        </div>
        <el-table
          v-if="Object.keys(accountTableData).length !== 0 "
          v-loading="loading"
          :data="accountTableData.list"
          style="width: 100%"
          :height="tatleHeight - 130"
        >

          <el-table-column
            label="删除"
            align="center"
            width="70"
          >
            <template slot-scope="scope">
              <i class="el-icon-close deleteIcon" @click="deleteData(scope.row)" />
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            :label="+item.platform_id === 100 ? '渠道号' : '公众号名称'"
            :width="+item.platform_id === 100 ? 170 : 140"
          >
            <template slot-scope="scope">
              <div style="display: flex; align-items: center; justify-content: space-between;">
                <span style="    white-space: break-spaces;">{{ scope.row.name.split(',').join('\n') }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            v-for="item,index in allattach"
            :key="index"
            prop="gap_time"
            :label="item.description"
            align="center"
            width="180"
          >
            <template
              slot-scope="scope"
            >
              <span v-if="scope.row.attach_info[index]">{{ scope.row.attach_info[index].param }}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="gap_time"
            label="最后更新时间"
            align="center"
            width="180"
          >
            <template slot-scope="scope">
              <span>
                {{ scope.row.last_ext_time }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="last_ext_index"
            label="最后一次执行位置"
            width="200"
          >
            <template slot-scope="scope">
              <span>
                <div
                  v-if="scope.row.last_ext_index !== undefined"
                  class="status"
                >
                  <div>
                    {{ scope.row.time_part !== null && scope.row.time_part ? (scope.row.time_part[scope.row.last_ext_slot_index] ? scope.row.time_part[scope.row.last_ext_slot_index].time_part[scope.row.last_ext_index].time : '--' ) : '--' }}<i style="color: #ccc; font-style: normal;">&nbsp;/&nbsp;分钟</i>
                  </div>
                  <div>
                    {{ judgmentState(scope.row, accountTableData.struct) }}
                  </div>
                  <div>
                    {{ scope.row.time_part ? accountTableData.struct[whichType(scope.row)] ? accountTableData.struct[whichType(scope.row)].description : '' : '--' }}
                  </div>
                </div>
                <span v-else>
                  --
                </span>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="错误信息"
            width="100"
            align="center"
          >
            <template v-if="scope.row.errinfo.length" slot-scope="scope">
              <i class="el-icon-warning" :title="scope.row.errinfo.map(err => err.exception_info).join('\n')" />
              <span
                style="display: inline-block; margin-left: 6px; color: #43c5f7; font-size: 13px; cursor: pointer;"
                @click="clearErrorMessages(scope.row.id)"
              >清除</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
          >
            <template scope="scope">
              <div style="position: relative; display: inline-block; margin-left: 10px;">
                <el-switch
                  :key="key"
                  v-model="scope.row.status"
                  :width="60"
                  active-color="#13ce66"
                  inactive-color="rgb(191,191,191)"
                  :active-value="1"
                  :inactive-value="0"
                  @change="statusChange(scope.row)"
                />
                <div
                  v-if="scope.row.status === 1"
                  style="color: #fff;position: absolute;top: 2px;left: 7px;"
                > {{ +item.platform_id === 100 ? accountTableData.struct ? accountTableData.struct[0].description : '正常' : '正常' }}</div>
                <div
                  v-else
                  style="color: #fff;position: absolute;top: 2px;right: 7px;"
                >{{ +item.platform_id === 100 ? accountTableData.struct ? accountTableData.struct[1].description : '禁用' : '禁用' }}</div>
              </div>
              <div style="display: inline-block; margin-left: 25px;">
                <el-button
                  type="text"
                  size="small"
                  @click="modify(scope.row)"
                >{{ !isModify ? '修改' : scope.row.id === isModify ? '确定' : '修改' }}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

      </div>
      <pagination-right
        :total="accountTableData.total"
        :page-sizes="[10]"
        @current-change="fetchCurrentPage"
      />
    </div>
  </drawer>
</template>

<script>
import Drawer from '@/components/Drawer/index.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { accountList, addAccountItem, updateAccount, deleteAccount, myClearErrorMessages } from '@/api/providerAccountManagement/WeChatAccountFans'

// import { filterAsyncRoutes } from '@/store/modules/permission'

export default {
  name: 'AddAccountDrawer',
  components: {
    Drawer,
    PaginationRight
  },
  props: {
    tableData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      huiarr: [],
      obj: {},
      arrr: [],
      allattach: [],
      drawerAccountListQuery: { // 抽屉表格列表数据请求参数
        account_id: null,
        wechat_name: null,
        page: 1,
        page_size: 10
      },
      xuan: {
        id: null,
        type: null
      },
      rules: {
        time_part: [
          { required: true, message: '时间分隔不能为空', trigger: 'change' }
        ]
      },
      addAccountQuery: { // 添加公众号请求参数
        account_id: null,
        name: null,
        time_part: [{
          start_time: '00:00',
          end_time: '23:59',
          isOpen: true, // 控制是否展开
          return_caliber: null,
          time_part: [{
            time: null,
            status: 'on'
          }, {
            time: null,
            status: 'on'
          }]
        }],
        attach: []
      },
      updateAccountQuery: { // 更新粉丝状态请求参数
        status: null
      },
      time_part: [],
      drawerVisible: false, // 抽屉开关
      accountTableData: {}, // 公众号数据信息
      key: null, // 用于驱动vue更新视图
      columnKey: null, // 用于驱动vue更新视图
      modifyBtnFlag: false, // 按钮开关
      selectType: null, // 选中的类型
      isModify: false,
      item: null,
      tatleHeight: (window.innerHeight - 44) / 2
    }
  },
  created() {
    window.aaa = this
  },
  methods: {
    whichType(data) {
      for (let i = 0; i < this.accountTableData.struct.length; i++) {
        if (this.accountTableData.struct[i].value === data.time_part[data.last_ext_index] ? data.time_part[data.last_ext_index].status : '') {
          return i
        }
      }
    },
    getSelectType(type) {
      let text = type
      switch (type) {
        case 'pyq': text = 'MP'
          break
        case 'gdt' : text = 'ADQ'
          break
      }

      return text
    },

    // 添加公众号请求
    addAccountData() {
      const arr = []
      const obj = { ...this.addAccountQuery }

      // 处理填选区
      for (const i in this.addAccountQuery.attach) {
        const prop = this.addAccountQuery.attach[i].param
        arr.push({ [prop]: this.addAccountQuery.attach[i].text })
      }

      obj.attach = arr

      obj.time_part = this.addAccountQuery.time_part.map((item) => {
        return {
          start_time: item.start_time,
          end_time: item.end_time,
          return_caliber: item.return_caliber || 0,
          time_part: item.time_part
        }
      })

      addAccountItem(obj).then(res => {
        this.$message({
          message: '添加成功',
          type: 'success'
        })
        this.getAccountList() // 请求数据

        // 清空表单输入项
        this.addAccountQueryReset()
      })
    },
    // 获取公众号
    getAccountList() {
      this.loading = true
      accountList(this.drawerAccountListQuery).then(res => {
        this.accountTableData = res.data
        this.loading = false

        // 向数据中添加属性
        for (let i = 0; i < this.accountTableData.list.length; i++) {
          this.$set(this.accountTableData.list[i], 'show', false)
          this.$set(this.accountTableData.list[i], 'name1', this.accountTableData.list[i].name)
        }

        this.allattach = res.data.attach
        if (res.data.attach.length !== 0) {
          for (let i = 0; i < res.data.attach.length; i++) {
            this.$set(res.data.attach[i], 'text', '')
          }
          this.addAccountQuery.attach = res.data.attach
        }
        console.log(this.addAccountQuery)
      })
    },
    // 更新公众号(粉丝状态)
    updateAccountItem(id, data, arr1) {
      updateAccount(id, data).then(res => {
        this.getAccountList()
        this.isModify = false
        this.xuan = {
          id: null,
          type: null
        }
        this.addAccountQuery = { // 添加公众号请求参数
          account_id: this.addAccountQuery.account_id,
          name: null,
          time_part: [{
            start_time: null,
            end_time: null,
            isOpen: true, // 控制是否展开
            return_caliber: null,
            time_part: [{
              time: null,
              status: 'on'
            }, {
              time: null,
              status: 'on'
            }]
          }],
          attach: []
        }
        this.$message({
          message: '更新成功',
          type: 'success'
        })
      }).catch(() => {
        /* this.addAccountQuery.attach = arr1 */
      })
    },
    // 删除列表的公众号
    deleteAccountItem(id) {
      deleteAccount(id).then(res => {
        this.getAccountList()
        this.$message({
          message: '删除成功',
          type: 'success'
        })
      })
    },
    // 清除公众号请求参数
    addAccountQueryReset() {
      this.addAccountQuery = { // 添加公众号请求参数
        account_id: this.addAccountQuery.account_id,
        name: null,
        time_part: [{
          start_time: '00:00',
          end_time: '23:59',
          isOpen: true, // 控制是否展开
          return_caliber: null,
          time_part: [{
            time: null,
            status: 'on'
          }, {
            time: null,
            status: 'on'
          }]
        }],
        attach: []
      }
      this.selectType = null

      this.xuan = {
        id: null,
        type: null
      }

      // 显示添加按钮
      this.modifyBtnFlag = false
    },
    // 添加账号
    add() {
      if (this.ruleEmptyData(this.addAccountQuery.time_part)) {
        return
      }

      const obj = this.judgeWhether1() // 判断时间差值是否符合条件

      // 判断条件是否符合
      if (this.addAccountQuery.account_id && this.addAccountQuery.name && obj.bool) {
        this.addAccountData() // 添加公众号请求
      } else {
        this.$message({
          message: obj.bool ? '任一输入项不能为空' : obj.text,
          type: 'error'
        })
      }
    },

    // 判断时间差值是否符合条件
    judgeWhether1() {
      for (let i = 0; i < this.addAccountQuery.time_part.length; i++) {
        const item = this.addAccountQuery.time_part[i]
        if (!item.start_time || !item.end_time) {
          return {
            bool: false,
            text: '起始时间和结束时间不能为空'
          }
        }
        const a = item.end_time.split(':')
        const b = item.start_time.split(':')

        const difference = (a[0] - b[0]) * 60 + (a[1] - b[1]) // 差值
        var num = 0

        for (let l = 0; l < item.time_part.length; l++) {
          const item1 = this.addAccountQuery.time_part[i].time_part[l]
          num += item1.time
        }
        if (difference <= num) {
          return {
            bool: false,
            text: '时间总和大于等于开始时间与结束时间的差值，请修改'
          }
        }
      }
      return {
        bool: true
      }
    },

    // 增加状态
    addTimeInput() {
      this.addAccountQuery.time_part.push({
        start_time: '00:00',
        end_time: '23:59',
        isOpen: true,
        return_caliber: null,
        time_part: [{
          time: null,
          status: 'on'
        }, {
          time: null,
          status: 'on'
        }]
      })
      this.columnKey = Math.random() * 100
    },

    // 添加状态中的项
    addTimePart(index) {
      this.addAccountQuery.time_part[index].time_part.push({
        time: null,
        status: 'on'
      })
    },

    // 删除状态中的指定子项
    deleteTimeItem(index, index1) {
      this.addAccountQuery.time_part[index].time_part.splice(index1, 1)
    },

    // 删除input输入框
    deleteTimeInput(index) {
      this.addAccountQuery.time_part.splice(index, 1)
      this.columnKey = Math.random() * 100
    },
    // 改变粉丝状态
    statusChange(e) {
      this.updateAccountQuery.status = e.status
      this.updateAccountItem(e.id, this.updateAccountQuery)
    },
    // 打开抽屉
    open(e, wechat_name) {
      this.item = e
      this.drawerVisible = true
      this.addAccountQuery.account_id = e.id
      this.addAccountQuery.attach = []
      this.drawerAccountListQuery.account_id = e.id
      this.drawerAccountListQuery.page = 1
      this.drawerAccountListQuery.wechat_name = wechat_name
      this.getAccountList()
    },

    // 关闭
    close() {
      // 关闭重置输入框数据
      this.addAccountQueryReset()
      this.modifyBtnFlag = false
      this.drawerVisible = false
      this.isModify = false
      this.selectType = null
      this.xuan = {
        id: null,
        type: null
      }
    },
    // 获取抽屉表格列表下一页的数据
    fetchCurrentPage(e) {
      this.drawerAccountListQuery.page = e
      this.getAccountList()
    },
    // 取消修改
    cancelModifyData(index) {
      // this.formTableData = {}
      this.addAccountQueryReset()
      this.cancelModifyFansData(index)
    },
    // 判断输入项是否为空或不符合要求
    ruleEmptyData(data) {
      for (let i = 0; i < data.length; i++) {
        for (let l = 0; l < data[i].time_part.length; l++) {
          if (data[i].time_part[l].time === null || data[i].time_part[l].time === '' || data[i].time_part[l].time < 1) {
            this.$message({
              message: '间隔时间不能为空或小于1，请先填写数据或删除该项',
              type: 'error'
            })
            return true
          }
        }

        if (!data[i].return_caliber) {
          this.$message.warning(`回传类型 ${this.xuan.type || ''} 选择不能为空`)
          return true
        }
      }
    },
    // 确认修改
    confirmModifyData(e) {
      if (this.ruleEmptyData(this.addAccountQuery.time_part)) {
        return
      }
      // this.addAccountQuery.time_part = this.filterEmptyData(this.addAccountQuery.time_part)
      this.updateAccountQuery = this.addAccountQuery
      if (this.updateAccountQuery.name && this.updateAccountQuery.time_part) {
        this.confirmModifyFansData(e.id, this.updateAccountQuery)
        this.addAccountQueryReset()
        // this.formTableData = {}
        this.updateAccountQuery = { status: null }
        this.key = Math.random()
        return
      } else {
        this.updateAccountQuery = { status: null }
        this.$message({
          message: '任一输入项都不能为空',
          type: 'error'
        })
      }
    },
    // 修改抽屉表格粉丝数据(发送请求修改数据)
    confirmModifyFansData(id, data) {
      this.updateAccountQuery = data
      this.updateAccountItem(id)
    },
    // 取消修改粉丝数据
    cancelModifyFansData(index) {
      this.accountTableData.list[index].show = false
      this.key = Math.random()
    },
    // 删除粉丝数据项
    deleteData(e) {
      this.$confirm(`是否删除 ${e.name}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        this.deleteAccountItem(e.id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },

    // 参数为点击的哪一项
    handleSingleChoice(item) {
      if (this.accountTableData.struct.length <= 2) {
        return
      }

      if (item === 'off') {
        let bool = true
        // 处理是否全关
        for (let i = 0; i < this.addAccountQuery.time_part.length; i++) {
          for (let l = 0; l < this.addAccountQuery.time_part[i].time_part.length; l++) {
            const im = this.addAccountQuery.time_part[i].time_part[l]
            if (im.status !== 'on' && im.status !== 'off') {
              bool = false
              break
            }
          }
        }

        // 判断是否全部选关
        if (bool) {
          this.selectType = null
          this.xuan = {
            id: this.xuan.id,
            type: null
          }
        }

        return
      }

      this.xuan = {
        id: null,
        type: item
      }

      this.selectType = item
    },

    /**
     * 判断是否禁用
     * index  索引
     * key    值
     */
    judgeWhether(index, key) {
      // 当前公众号中是否状态数据少于2项
      if (this.accountTableData.struct.length <= 2) {
        return false
      }

      // 判断选项是否为关
      if (key === 'off') {
        return false
      }

      if ((this.selectType === 'gdt') && key === 'pyq') {
        return true
      }

      if ((this.selectType === 'pyq') && key === 'gdt') {
        return true
      }

      if ((this.selectType === 'ADQ') && key === 'MP') {
        return true
      }

      if ((this.selectType === 'MP') && key === 'ADQ') {
        return true
      }

      if ((this.selectType === 'OCEAN') && key === 'ADQ') {
        return true
      }

      if ((this.selectType === 'ADQ') && key === 'OCEAN') {
        return true
      }

      return false
    },

    /**
     * 点击项
     * bool
     * key     类型
     * index   索引
     */
    qiehuan(bool, key, index, index1) {
      if (bool) {
        this.$confirm(`是否切换成${key}`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          for (let i = 0; i < this.addAccountQuery.time_part.length; i++) {
            for (let l = 0; l < this.addAccountQuery.time_part[i].time_part.length; l++) {
              const item = this.addAccountQuery.time_part[i].time_part[l]
              if (item.status === 'on' || item.status === 'off') {
                continue
              }
              item.status = key
              this.selectType = key
            }
          }
          this.addAccountQuery.time_part[index].time_part[index1].status = key
          this.addAccountQuery.time_part[index].return_caliber = null
          this.xuan = {
            id: null,
            type: key === 'off' ? null : key
          }
          this.$message({
            type: 'success',
            message: '切换成功'
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      }
    },

    // 点击修改按钮或确定按钮时触发
    modify(item) {
      if (!this.isModify || (this.isModify !== item.id)) {
        this.huiarr = []

        // 处理选中的东西
        const caliber = this.getStatus(item.time_part)

        if (caliber) {
          this.xuan.type = caliber.status // 状态
          if (this.accountTableData.returnCaliber[this.xuan.type]) {
            // 获取选中的那一项
            const s = this.accountTableData.returnCaliber[this.xuan.type].filter(item1 => +item1.value === +item.time_part[0].return_caliber)
            this.xuan.id = s.length ? s[0].return_caliber : null
          }
        }

        // 循环那些密钥的东西
        if (item.attach.length !== 0) {
          for (let k = 0; k < this.addAccountQuery.attach.length; k++) {
            item.attach.forEach((value, i) => { // 数组循环
              for (var pl in value) { // 数组对象遍历
                // eslint-disable-next-line eqeqeq
                if (pl == this.addAccountQuery.attach[k].param) {
                  this.huiarr.push({
                    description: this.addAccountQuery.attach[k].description,
                    param: pl,
                    text: value[pl]
                  })
                }
              }
            })
          }
        }

        // 处理选中的来禁用指定项
        if (this.accountTableData.struct.length > 2) {
          for (let i = 0; i < item.time_part.length; i++) {
            for (let l = 0; l < item.time_part[i].time_part.length; l++) {
              const im = item.time_part[i].time_part[l]
              if (im.status !== 'off' && im.status !== 'on') {
                const index2 = this.accountTableData.struct.findIndex(imm => imm.value === im.status && imm.value !== 'off' && imm.value !== 'on')
                index2 !== -1 && (this.selectType = this.accountTableData.struct[index2].value) // 赋值选中的
              }
            }
          }
        }

        this.addAccountQuery = {
          account_id: this.addAccountQuery.account_id,
          name: item.name,
          time_part: item.time_part.map((itemm) => {
            return {
              ...itemm,
              isOpen: true,
              return_caliber: itemm.return_caliber || null // 选中的那一项
            }
          }),
          attach: this.huiarr
        }

        this.isModify = item.id
      } else {
        console.log('确定')

        const obj = this.judgeWhether1()
        if (!this.addAccountQuery.account_id || !this.addAccountQuery.name || !obj.bool) {
          this.$message({
            message: obj.bool ? '任一输入项不能为空' : obj.text,
            type: 'error'
          })
          return
        }

        const arr = []

        for (const i in this.addAccountQuery.attach) {
          const prop = this.addAccountQuery.attach[i].param
          arr.push({ [prop]: this.addAccountQuery.attach[i].text })
        }

        const obj1 = { ...this.addAccountQuery, status: item.status, return_caliber: this.xuan.id, attach: arr }

        obj1.time_part = obj1.time_part.map((item) => {
          return {
            start_time: item.start_time,
            end_time: item.end_time,
            return_caliber: item.return_caliber || 0,
            time_part: item.time_part
          }
        })

        this.updateAccountItem(item.id, obj1)
      }
    },

    // 获取状态
    getStatus(time_part) {
      for (let i = 0; i < time_part.length; i++) {
        const item = time_part[i]
        for (let l = 0; l < item.time_part.length; l++) {
          const item1 = item.time_part[l]
          if (item1.status !== 'off' && item1.status !== 'on') {
            return item1
          }
        }
      }
      return false
    },

    // 处理最后一次执行的位置
    judgmentState(row, struct) {
      const s = struct.filter((item) => {
        if (!row.time_part || !row.time_part[row.last_ext_slot_index] || !row.time_part[row.last_ext_slot_index].time_part) {
          return null
        }
        return item.value === row.time_part[row.last_ext_slot_index].time_part[row.last_ext_index].status
      })

      return s.length ? s[0].description : null
    },

    // 清除错误信息
    clearErrorMessages(id) {
      this.$confirm('是否确定清除错误消息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        await myClearErrorMessages({ wechat_id: id })
        this.getAccountList()
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消清除'
        })
      })
    },

    // 搜索
    search() {
      this.drawerAccountListQuery.page = 1
      this.drawerAccountListQuery.page_size = 10
      this.getAccountList()
    },

    reset() {
      this.drawerAccountListQuery.page = 1
      this.drawerAccountListQuery.page_size = 10
      this.drawerAccountListQuery.wechat_name = null
      this.getAccountList()
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  margin: 0 auto;
  padding: 0 5%;
  height: calc(100% - 43px);
  .status {
    display: flex;
    div {
      width: 180px;
    }
  }
}
.top {
  max-width: 900px;
  margin: 0 auto;
  overflow: auto;
  max-height: 50%;
  .confirm-btn {
    margin-left: 20px;
    float: right;
  }
  .status-box {
    overflow: auto;
    max-height: 263px;
  }
}
.bottom {
  // width: 800px;
  // height: 500px;
  margin: 50px auto;
  padding-right: 16px;
  overflow: hidden;
  position: relative;
  overflow-y: auto;
  /* height: 400px; */
}
.column-display {
  display: flex;
  align-content: center;
  justify-content: center;
  margin-top: 20px;
}
.input-border {
  width: 60px;
  border: 1px solid #ccc;
  height: 30px;
  border-radius: 5px;
}
/deep/ .row-display {
  margin-left: 20px;
  font-size: 15px;
}
.deleteIcon{
  cursor: pointer;
  color: rgb(204, 204, 204);
  &:hover{
    font-weight: bold;
    color: black;
  }
}

/deep/ .el-select{
  width: 100%;
}

/*里面的代码可以根据自己需求去进行更改*/
/* 设置滚动条的样式 */
::-webkit-scrollbar {
width:12px;
}
/* 滚动槽 */
::-webkit-scrollbar-track {
-webkit-box-shadow:inset006pxrgba(0,0,0,0.3);
background:#ccc;
border-radius:10px;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
border-radius:10px;
background:rgb(160, 157, 157);
-webkit-box-shadow:inset006pxrgba(0,0,0,0.5);
}
::-webkit-scrollbar-thumb:window-inactive {
background:rgb(160, 157, 157);
}
/* ==== */
.aa::-webkit-scrollbar {
width:12px;
}
/* 滚动槽 */
.aa::-webkit-scrollbar-track {
-webkit-box-shadow:inset006pxrgba(0,0,0,0.3);
background:#ccc;
border-radius:10px;
}
/* 滚动条滑块 */
.aa::-webkit-scrollbar-thumb {
border-radius:10px;
background:rgb(50, 153, 201);
-webkit-box-shadow:inset006pxrgba(0,0,0,0.5);
}
.aa::-webkit-scrollbar-thumb:window-inactive {

}
.el-date-editor{
  height: fit-content;
}
</style>

<style>
/* .el-input__icon  {
  height: 0px !important;
} */

.timeSelectionArea{
  width: 268px;
}

.timeSelectionArea .el-form-item__label{
  width: auto !important;
}
.timeSelectionArea .el-form-item__content{
    margin-left: 0px !important;
    width: 212px;
    display: flex;
}
</style>

<style>
  .myType .el-form-item{
     display: flex;
  }
  .myType .el-form-item .el-form-item__label{
    white-space: pre;
  }
</style>
